module.exports = new __parcel__URL__("Sales Account Planning.7875e2a4.svg").toString();